import DOMPurify from "dompurify";

// Backend already sanitizes with bleach; this is defense-in-depth before rendering HTML.
export function SafeHtml({ html, className, testId }) {
  return <div className={className} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true } }) }} data-testid={testId} />;
}
